<div class="blotter-dialog-container">
  <ag-grid-angular
    class="ag-bcdfx"
    enableColResize
    enableSorting
    (contextmenu)="handleClick($event)"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [showToolPanel]="false"
  >
  </ag-grid-angular>
  <bfx-blotter-column-selector
    class="blotter-dialog-empty-body-element"
    [currentLadderBlotter]="blotterInstance"
    bfxElementOnBody
  ></bfx-blotter-column-selector>

  <div class="blotter-dialog-form">
    <span>Transfer {{orderRecords.length}} order(s) to:</span>
    <div class="order-transfer-target-form">
      <bfx-autoComplete
        #targetInput
        size="sm"
        [disabled]="progressStatus > 0"
        inputId="target-input"
        [(ngModel)]="targetGroup"
        [suggestions]="targetGroupSuggestions"
        (completeMethod)="searchTargetGroup($event)"
        [useAlternateBlur]="true"
        [alternateConfig]="control.traderGroupAutocompleteConfig"
        (onSelect)="onSelectTargetGroup($event)"
        (onBlur)="validateTargetGroup()"
        [dropdown]="true"
        autofocus="true"
        delay="5"
        appendTo="body"
        nativeDesktopDropdown="transferTargetGroup"
        target="transferTargetGroup"
        field="label"
        dataKey="value"
        label="Trader Group"
        [minLength]="0"
        [maxlength]="50"
      >
      </bfx-autoComplete>
      <div class="order-transfer-reason">
        <span>
          <bfx-text-input
            #reasonInput
            id="reason-input"
            inputLabelText="Reason (optional)"
            autocomplete="off"
            [(ngModel)]="comment"
            size="sm"
            [disabled]="progressStatus > 0"
            size="sm"
            [maxLength]="100"
            [ngClass]="{
              'comment-input':true,
              'valid': true}"
            (blur)="validateCommentInput($event)"
            (focus)="commentFocus($event)"
          ></bfx-text-input>
        </span>
        <bfx-comment-warning></bfx-comment-warning>
      </div>
    </div>
  </div>
  <div class="blotter-dialog-footer">
    <div class="blotter-dialog-status" *ngIf="!showTransfer">
      <div class="bfx-callout-negative-sm" *ngIf="message">
        <i class="icon-error"></i>
        <span>{{message}}</span>
      </div>
      <div class="progress-bar-container" *ngIf="!message">
        <div class="progress-bar-track"></div>
        <div class="progress-bar-indicator" [style.width.%]="progress"></div>
      </div>
    </div>

    <div class="flex-spacer"></div>
    <div class="action-button-group">
      @if (showClose) {
      <button pButton class="bfx-button-secondary-moderate" (click)="parentPopout.close()">
        Close
      </button>
      } @if (showTransfer) {
      <button
        [disabled]="targetGroupValid !== true"
        pButton
        class="bfx-button-primary"
        (click)="transferOrders($event, targetInput)"
      >
        Transfer
      </button>
      } @if (showAbort) {
      <button pButton class="bfx-button-secondary-moderate" (click)="abort()">Abort</button>
      } @if (showReject ) {
      <button pButton class="bfx-button-negative-bold" (click)="reject()">{{rejectLabel()}}</button>
      } @if (showAccept ) {
      <button pButton class="bfx-button-primary-bold" (click)="accept()">{{acceptLabel()}}</button>
      }
    </div>
  </div>
</div>
